"use client";

import {
  createContext, type FC, type PropsWithChildren, useMemo,
} from "react";

import { usePathname } from "next/navigation";

import { shallowEqual } from "react-redux";

import { useAppSelector } from "../store/hooks";

import { NavigationMatcher } from "./navigation-matcher";

import { config } from "./index";

export const NavigationContext = createContext<NavigationMatcher | null>(null);

export const NavigationProvider: FC<PropsWithChildren> = ({ children }) => {
  const profile = useAppSelector((state) => state.user.profile, shallowEqual);
  const pathname = usePathname();

  const navigation = useMemo(() => {
    const navMatcher = NavigationMatcher.getInstance(config);
    navMatcher.setUserRoles(profile?.role ? [profile.role] : []);
    navMatcher.adjustPathname(pathname);
    return navMatcher;
  }, [profile, pathname]);
  return (
    <NavigationContext.Provider value={navigation}>
      {children}
    </NavigationContext.Provider>
  );
};
